import React from 'react';
import {HomeGameFloorItem} from '../home.type';
import {SportSwiperItemProps} from '../../gr8-sports/components/swiper-card';
import HomeCategory from '@/components/business/home-category/home-category';
import {Button} from 'antd-mobile';
import globalStore from '@/services/global.state';
import SportSwiperItem from '../../gr8-sports/components/swiper-card';
import {NotLive} from '@/const/home';
// console.log(NotLive);

const PreIcon = ({floor}: {floor: HomeGameFloorItem}) => {
  if (floor.uniqueKey === 'HotMatches') {
    return null;
  } else {
    return (
      <Button className="bg-[var(--live-bg)] text-white rounded-[0.325rem] text-xs w-[2.5rem] h-[1.2rem] font-size-10 flex items-center justify-center">
        Live
      </Button>
    );
  }
};

// 1. 抽取常量
// const SLIDE_WIDTHS = {
//   PROMOTION: 0.48,
//   GAME: 0.28,
//   SPORTS: '19rem',
// };

function isMixed(sports: SportSwiperItemProps[]) {
  let live: boolean | null = null;
  for (const sport of sports) {
    const preLive: boolean | null = live;
    if (sport.isLive || sport.isLive == null) {
      live = true;
    } else {
      live = false;
    }
    if (preLive != null && preLive !== live) {
      return true;
    }
  }
  return false;
}

// 3. 抽取体育赛事渲染逻辑
const renderSportsSection = (
  floor: HomeGameFloorItem,
  sports: SportSwiperItemProps[],
  noLink?: boolean,
) => {
  if (noLink) {
    return (
      <div className="mb-3">
        <HomeCategory
          key={floor.id}
          title={floor.name}
          icon={floor.categoryPic}
          preIcon={
            floor.isLive == null || floor.isLive ? (
              <PreIcon floor={floor} />
            ) : null
          }
          list={sports}
          // swiperSlideClassName={SLIDE_WIDTHS.SPORTS}
          swiperSlideClassName="w-[19rem]"
          rightContent={null}
          renderItem={card => (
            <SportSwiperItem
              isLive={card.isLive == null ? true : card.isLive}
              // isSport={false}
              isSport={!NotLive.includes(floor.uniqueKey)}
              isMix={isMixed(sports)}
              {...card}
              key={card.item.completeEventId}
              icon={floor.categoryPic}
              defaultClass={
                floor.uniqueKey === 'HotMatches'
                  ? 'bg-[linear-gradient(291deg,rgba(255,255,255,0)_0%,rgba(242,247,64,0.2)_97.72%)]'
                  : ''
              }
            />
          )}
        />
      </div>
    );
  }
  return (
    <div className="mb-3">
      <HomeCategory
        key={floor.id}
        title={floor.name}
        icon={floor.categoryPic}
        preIcon={
          floor.isLive == null || floor.isLive ? (
            <PreIcon floor={floor} />
          ) : null
        }
        list={sports}
        // swiperSlideClassName={SLIDE_WIDTHS.SPORTS}
        swiperSlideClassName="w-[19rem]"
        rightContent={
          <div
            onClick={() => {
              if (floor.uniqueKey === 'HotMatches') {
                return globalStore.openSports.next('/cricket');
              }
              if (floor.uniqueKey === 'TableTennis') {
                globalStore.openSports.next('/table-tennis/live');
                return;
              }
              if (floor.uniqueKey === 'CyberSport') {
                globalStore.openSports.next('/e-sports/live');
                return;
              }
              globalStore.openSports.next(`/${floor.uniqueKey.toLowerCase()}`);
            }}
            className="text-t3 text-[0.875rem]">
            {floor.isLive == null || floor.isLive ? 'All' : 'All Upcoming'}
          </div>
        }
        renderItem={card => (
          <SportSwiperItem
            isLive={true}
            // isSport={false}
            isSport={!NotLive.includes(floor.uniqueKey)}
            {...card}
            key={card.item.completeEventId}
            isMix={isMixed(sports)}
            icon={floor.categoryPic}
            defaultClass={
              floor.uniqueKey === 'HotMatches'
                ? 'bg-[linear-gradient(291deg,rgba(255,255,255,0)_0%,rgba(242,247,64,0.2)_97.72%)]'
                : ''
            }
          />
        )}
      />
    </div>
  );
};

export default renderSportsSection;
